export default "__VITE_ASSET__78d6705a__"